<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-8">
              <h3 class="mb-0">
                {{ salesPayment.name }}
                <base-button
                  v-if="
                    salesPayment.status == PAYMENT_STATUS_DRAFT &&
                    $currentUserCan($permissions.PERM_EDIT_SALES_PAYMENTS)
                  "
                  type="primary"
                  icon
                  size="sm"
                  @click="editSalesPayment()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="
                    salesPayment.status == PAYMENT_STATUS_DRAFT &&
                    $currentUserCan($permissions.PERM_DELETE_SALES_PAYMENTS)
                  "
                  type="danger"
                  icon
                  size="sm"
                  @click="deleteSalesPayment()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-trash"></i>
                  </span>
                </base-button>

                <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="viewInvoice()"
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-single-copy-04"></i>
                    {{ $t("SALES_PAYMENTS.VIEW_INVOICE") }}
                  </span>
                </base-button>
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack()"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>

              <notification-subscription
                :objectType="'salesPayments'"
                :objectId="salesPayment.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 justify-content-center justify-content-sm-between flex-wrap"
          >
            <tabs
              fill
              class="flex-column flex-md-row"
              tabNavWrapperClasses="nav-wrapper"
              tabNavClasses="nav nav-pills nav-fill"
              value="global"
            >
              <card shadow>
                <tab-pane title="global" id="1" :active="true">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GLOBAL") }}
                  </span>
                  <salesPayment-view-global :salesPayment="salesPayment" />
                </tab-pane>

                <tab-pane
                  title="files"
                  id="998"
                  v-if="
                    $currentUserCan($permissions.PERM_VIEW_ANY_FILES) &&
                    salesPayment.organization
                  "
                >
                  <span slot="title">
                    <i class="ni ni-folder-17" />
                    {{ $t("COMMON.FILES") }}
                  </span>
                  <list-file-component :object="salesPayment" />
                </tab-pane>

                <tab-pane
                  title="logs"
                  id="999"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
                >
                  <span slot="title">
                    <i class="fa fa-file" />
                    {{ $t("COMMON.LOGS") }}
                  </span>
                  <salesPayment-view-logs :salesPayment="salesPayment" />
                </tab-pane>
              </card>
            </tabs>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
import { PAYMENT_STATUS_DRAFT } from "@/constants/payments";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import SalesPaymentViewGlobal from "./partials/SalesPaymentViewGlobal.vue";
import SalesPaymentViewLogs from "./partials/SalesPaymentViewLogs.vue";
import defaultSalesPayment from "./defaultSalesPayment";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    SalesPaymentViewGlobal,
    SalesPaymentViewLogs,
    ListFileComponent,
    NotificationSubscription,
  },

  mixins: [],

  data() {
    return {
      salesPayment: cloneDeep(defaultSalesPayment),
      PAYMENT_STATUS_DRAFT: PAYMENT_STATUS_DRAFT,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("salesPayments/get", id);
        this.salesPayment = this.$store.getters["salesPayments/salesPayment"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async editSalesPayment(row) {
      this.$router.push({
        name: "Edit SalesPayment",
        params: { id: this.salesPayment.id },
      });
    },

    async deleteSalesPayment(id) {
      const confirmation = await swal.fire({
        title: this.$t("SALES_PAYMENTS.DELETE_THIS_SALES_PAYMENT"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("salesPayments/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: this.$t("SALES_PAYMENTS.SALES_PAYMENT_DELETED"),
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async viewInvoice() {
      this.$router.push(this.$objectViewRoute(this.salesPayment.invoice));
    },

    goBack() {
      this.$router.push({ name: "List SalesPayments" });
    },
  },
};
</script>
